module.exports = __webpack_public_path__ + "static/media/McKinseySans-Regular.5af70695.woff";